import {
  LayoutDashboard,
  Users,
  Calendar,
  Package,
  HeartHandshake,
  Settings,
} from 'lucide-react';

export interface NavigationItem {
  name: string;
  href: string;
  icon: any;
  color: string;
  badge?: {
    content: string;
    variant: 'default' | 'error';
  };
}

export const navigation: NavigationItem[] = [
  { 
    name: 'Dashboard', 
    href: '/', 
    icon: LayoutDashboard,
    color: 'text-blue-500 dark:text-blue-400 group-hover:text-blue-600 dark:group-hover:text-blue-300'
  },
  { 
    name: 'Patients', 
    href: '/patients', 
    icon: Users,
    color: 'text-emerald-500 dark:text-emerald-400 group-hover:text-emerald-600 dark:group-hover:text-emerald-300',
    badge: {
      content: '2',
      variant: 'default'
    }
  },
  { 
    name: 'Visits', 
    href: '/visits', 
    icon: Calendar,
    color: 'text-amber-500 dark:text-amber-400 group-hover:text-amber-600 dark:group-hover:text-amber-300'
  },
  { 
    name: 'Inventory', 
    href: '/inventory', 
    icon: Package,
    color: 'text-cyan-500 dark:text-cyan-400 group-hover:text-cyan-600 dark:group-hover:text-cyan-300',
    badge: {
      content: '3',
      variant: 'error'
    }
  },
  { 
    name: 'Outreach', 
    href: '/outreach', 
    icon: HeartHandshake,
    color: 'text-green-500 dark:text-green-400 group-hover:text-green-600 dark:group-hover:text-green-300'
  },
  { 
    name: 'Settings', 
    href: '/settings', 
    icon: Settings,
    color: 'text-gray-500 dark:text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300'
  },
];
